import React from 'react';
import Button from '../../../../components/button/Button';
import { PlusIcon } from '../../../../components/icons';
import { Field, FieldArray, useFormikContext } from 'formik';
import Input from '../../../../components/input/Input';
import { DocumentUploader } from '../../../../components/DocumentUploader';
import { ConnectFormValues } from './Details';
import { Divider } from 'antd';
import { getFileName } from '../../../../utils/helper';

export const SignatoryField = () => {
    const { values, errors, setFieldValue } = useFormikContext<
        ConnectFormValues
    >();

    return (
        <div className='mx-auto bg-white'>
            <div className='space-y-6'>
                <FieldArray name='signatories'>
                    {({ push, remove }) => (
                        <div className='space-y-4'>
                            {values.signatories.map((signature, index) => (
                                <div key={index}>
                                    {values.editingIndex === index ? (
                                        <div className='w-full space-y-4 pt-2'>
                                            <div>
                                                <h3 className='text-ebony text-base font-medium my-1'>
                                                    Add a signatory
                                                </h3>
                                                <p className='text-paleSky text-sm'>
                                                    Account signatories are
                                                    individuals authorized to
                                                    operate or approve
                                                    transactions on a business
                                                    account.
                                                </p>
                                            </div>
                                            <Field
                                                as={Input}
                                                className='w-full'
                                                placeholder='Enter signatory name'
                                                label='Signatory Name'
                                                name={`signatories.${index}.name`}
                                                id={`signatories.${index}.name`}
                                            />

                                            <DocumentUploader
                                                useAuthorization
                                                key={`signatories.${index}.url`}
                                                title='Upload Signature'
                                                runAfterUpload={true}
                                                accept='image/png,image/jpg,image/jpeg'
                                                acceptText='PNG or JPG (max. 800x400px)'
                                                documentItemId={1}
                                                uploaded={
                                                    !!signature.signatureUrl
                                                }
                                                documentUrl={
                                                    signature.signatureUrl
                                                }
                                                status={2}
                                                onUpload={(url: string) => {
                                                    setFieldValue(
                                                        `signatories.${index}.signatureUrl`,
                                                        url
                                                    );
                                                }}
                                            />
                                            <div className='flex'>
                                                <Button
                                                    text='Authorize'
                                                    disabled={
                                                        !signature.name ||
                                                        !signature.signatureUrl
                                                    }
                                                    onClick={() => {
                                                        setFieldValue(
                                                            'editingIndex',
                                                            null
                                                        );
                                                    }}
                                                />
                                                {index !== 0 && (
                                                    <Button
                                                        text='Cancel'
                                                        variant='tertiary'
                                                        onClick={() => {
                                                            remove(index);
                                                            setFieldValue(
                                                                'editingIndex',
                                                                null
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className='flex items-center justify-between'>
                                                <div className='flex items-start space-x-3'>
                                                    <div>
                                                        <p className='text-appcolorprimary text-base uppercase'>
                                                            {signature.name ||
                                                                'Unnamed Signature'}
                                                        </p>
                                                        <p className='text-sm text-gray-500'>
                                                            {signature?.signatureUrl
                                                                ? getFileName(
                                                                      signature.signatureUrl
                                                                          .split(
                                                                              '/'
                                                                          )
                                                                          .pop()
                                                                          ?.split(
                                                                              '?'
                                                                          )[0] ??
                                                                          ''
                                                                  )
                                                                : 'No file uploaded'}
                                                        </p>
                                                    </div>
                                                </div>
                                                <Button
                                                    type='button'
                                                    onClick={() => {
                                                        setFieldValue(
                                                            'editingIndex',
                                                            index
                                                        );
                                                    }}
                                                    text='Edit'
                                                    size='sm'
                                                    variant='tertiary'
                                                    className='text-appcolorprimary px-0 py-0 h-max hover:bg-white cursor-pointer'
                                                />
                                            </div>
                                            {index <
                                                values.signatories?.length -
                                                    1 && (
                                                <Divider
                                                    dashed
                                                    className='border-appcolorfaintgreyblue'
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                            {!values.editingIndex && (
                                <>
                                    {values.signatories?.length > 0 && (
                                        <Divider
                                            dashed
                                            className='border-appcolorfaintgreyblue mt-8'
                                        />
                                    )}
                                    <Button
                                        variant='tertiary'
                                        className='text-appcolorprimary px-0 py-0 h-max hover:bg-white cursor-pointer'
                                        text='Add Signatory'
                                        leftIcon={
                                            <PlusIcon color='currentColor' />
                                        }
                                        onClick={() => {
                                            setFieldValue(
                                                'editingIndex',
                                                values.signatories.length
                                            );
                                            push({ name: '', file: null });
                                        }}
                                    />
                                </>
                            )}
                        </div>
                    )}
                </FieldArray>

                {errors.signatories &&
                    typeof errors.signatories === 'string' && (
                        <div className='text-red-500 text-sm'>
                            {errors.signatories}
                        </div>
                    )}
            </div>
        </div>
    );
};
